import React from 'react';
import { AlertCircle, CheckCircle2, HelpCircle, Info, X } from 'lucide-react';
import { ui } from './ui/styles';

const ICONS = {
  confirm: HelpCircle,
  alert: AlertCircle,
  info: Info,
  success: CheckCircle2,
  error: AlertCircle,
};

const ICON_COLORS = {
  confirm: 'text-primary bg-primary-light',
  alert: 'text-amber-600 bg-amber-50',
  info: 'text-primary bg-primary-light',
  success: 'text-emerald-600 bg-emerald-50',
  error: 'text-danger bg-red-50',
};

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'confirm',
  onConfirm,
  onCancel,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  children,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    onClose();
  };

  const Icon = ICONS[type] || HelpCircle;

  return (
    <div className={ui.modalOverlay} onClick={handleOverlayClick}>
      <div className={`${ui.modal} max-w-lg`} role="dialog" aria-modal="true">
        <div className={ui.modalHeader}>
          <div className="flex items-center gap-3">
            <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${ICON_COLORS[type] || ICON_COLORS.confirm}`}>
              <Icon size={18} />
            </div>
            <h3 className="text-lg font-semibold text-text">{title}</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-muted transition hover:bg-slate-100 hover:text-text"
            aria-label="Fechar"
          >
            <X size={18} />
          </button>
        </div>

        <div className={ui.modalBody}>
          {message && <p className="text-sm leading-relaxed text-muted">{message}</p>}
          {children}
        </div>

        {type === 'confirm' && (
          <div className={ui.modalFooter}>
            <button type="button" className={ui.btn} onClick={handleCancel}>
              {cancelText}
            </button>
            <button type="button" className={ui.btnPrimary} onClick={handleConfirm}>
              {confirmText}
            </button>
          </div>
        )}

        {(type === 'alert' || type === 'info' || type === 'success' || type === 'error') && (
          <div className={ui.modalFooter}>
            <button type="button" className={ui.btnPrimary} onClick={handleConfirm}>
              OK
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
